import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import analyticsReducer from '../features/analytics/analyticsSlice';
import instagramReducer from '../features/instagram/instagramSlice';

export const rootReducer = combineReducers({
  auth: authReducer,
  analytics: analyticsReducer,
  instagram: instagramReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
